import z from 'zod';

const socialMediaPost = z.object({
  type: z.literal('social_media_post'),
  postLink: z.string(),
});

const inviteBonus = z.object({
  type: z.literal('invite_bonus'),
  invitedEmails: z.string().array(),
});

export const rewardSubmission = z.union([socialMediaPost, inviteBonus]);
export type RewardSubmission = z.infer<typeof rewardSubmission>;
